import React from 'react';
export var Download = function Download(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
    points: "0,47.8 0,32.9 4.5,32.9 4.5,43.3 43.5,43.3 43.5,32.9 48,32.9 48,47.8 \t\t"
  }))), React.createElement("g", null, React.createElement("polygon", {
    points: "13.5,27.1 13.5,20.6 21.7,28.9 21.7,0.2 26.3,0.2 26.3,28.9 34.5,20.6 34.5,27.1 24,37.6 \t"
  })));
};